// SPDX-License-Identifier: AGPL-3.0-or-later

import {wrapMeEmoteContent} from '@app/features/messaging/utils/MessageEmoteUtils';
import Users from '@app/features/user/state/Users';

const NZ_USER_IDS: ReadonlySet<string> = new Set(['1541681487164735488', '1543128359616118786']);

/** Silent /me-style wire content posted when glmode is enabled. */
export const GLMODE_ENABLE_EMOTE = `@silent ${wrapMeEmoteContent('enters /glmode')}`;

/** Toggles glmode. Returns true when enabled, false when disabled. */
export function toggleGlMode(): boolean {
	const root = document.documentElement;
	if (root.hasAttribute('data-glmode')) {
		root.removeAttribute('data-glmode');
		return false;
	}
	const currentUserId = Users.currentUserId;
	root.dataset.glmode = currentUserId != null && NZ_USER_IDS.has(currentUserId) ? 'nz' : 'us';
	return true;
}
